import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const InputTag = ({
	id,
	formField,
	label,
	filtersActive,
	selector,
	fetchAction,
	isTranslated = false,
	translationKey = '',
	freeInput = false,
	valueType = 'string',
	valueKey = 'name',
	multiselect = true,
	isFilter = true,
	placeholder = '',
}) => {
	const dispatch = useDispatch();
	const [searchQuery, setSearchQuery] = useState('');
	const list = useSelector(selector[0]);
	const [filters, setFilters] = useState([]);
	const dropdownRef = useRef();
	const [isActive, setIsActive] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (searchQuery?.trim()?.length > 0) {
			fetchData();
		}
	}, [searchQuery]);

	function fetchData() {
		if (searchQuery?.trim()?.length > 0) {
			dispatch(
				fetchAction[0]({
					page: 0,
					filter:
						valueType === 'string'
							? `name-like=${searchQuery}`
							: `page=0&size=10&filter=${valueKey}:LIKE_IC:${searchQuery}`,
				})
			);
		} else {
			dispatch(fetchAction[0]({ page: 0, filter: '' }));
		}
	}

	useEffect(() => {
		if (!filtersActive) {
			setIsActive(false);

			setSearchQuery('');
			setFilters([]);
		}
	}, [filtersActive]);

	useEffect(() => {
		if (formField.value && multiselect) {
			if (Array.isArray(formField.value)) {
				const _values = [];
				formField.value.map((item) => {
					isFilter
						? item.name
							? _values.push(item.name)
							: _values.push(item)
						: _values.push(item);
				});
				setFilters(_values);
			} else {
				setFilters([...formField.value]);
			}
		} else if (formField.value) {
			if (valueType !== 'string') {
				if (
					typeof formField.value !== 'string' &&
					!Array.isArray(formField.value)
				) {
					setFilters([formField.value.name]);
				} else if (Array.isArray(formField.value)) {
					const _values = [];
					formField.value.map((item) =>
						item.name ? _values.push(item.name) : _values.push(item)
					);
					setFilters(_values);
				} else {
					setFilters([formField.value]);
				}
			} else {
				if (formField.value) setFilters([formField.value]);
			}
		}

		if (!formField.value) {
			setFilters([]);
		}
	}, [formField.value]);

	const setNewItem = (value) => {
		if (multiselect) {
			const _filters = [...filters, value];
			setFilters(_filters);
			formField.setValue(_filters, false, true);
			setSearchQuery('');
			setIsActive(false);
		} else {
			if (isFilter) {
				setFilters([value]);
				formField.setValue([value]);
			} else {
				setFilters([value]);
				formField.setValue(value, false, true);
			}

			setSearchQuery('');
			setIsActive(false);
		}
	};

	const removeFilter = (filter) => {
		const _filters = filters.filter((item) => item !== filter);
		formField.setValue(_filters, false, true);
		setFilters(_filters);
	};

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsActive(false);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const fetchInitialData = () => {
		setIsActive(true);
		if (list.length === 0 || searchQuery?.trim()?.length === 0) {
			fetchData();
		}
	};

	return (
		<div className="my-2">
			<label htmlFor={id}>{label}</label>
			<div
				ref={dropdownRef}
				className={`input-tag-container ${
					multiselect ? 'input-tag-container-multiselect' : ''
				}`}>
				<div className="input-tags">
					{filters &&
						filters.length > 0 &&
						filters.map((filter, index) => (
							<div key={index} className="input-tag">
								<span>
									{isTranslated && !freeInput
										? t(translationKey + '.' + filter)
										: isFilter
										? filter
										: filter?.name || filter}
								</span>
								<i
									className="icon fz fz-times"
									onClick={() => {
										removeFilter(filter);
									}}
								/>
							</div>
						))}
				</div>
				<div className="dropdown">
					<div className="dropdown-input">
						<input
							id={id}
							type="search"
							className="input"
							value={searchQuery}
							onChange={(e) => {
								if (!isActive && e.target.value?.trim()?.length > 0) {
									setIsActive(true);
								}
								setSearchQuery(e.target.value);
							}}
							onKeyDown={(e) => {
								if (e.keyCode === 13 && freeInput) {
									e.preventDefault();
									e.stopPropagation();
									setNewItem(searchQuery);
								}
							}}
							onFocus={() => fetchInitialData()}
							placeholder={multiselect ? placeholder || label : ''}
						/>
						<i
							className="icon fz-chevron-down"
							onClick={() => fetchInitialData()}
						/>
					</div>
					{isActive && list?.content?.length > 0 && (
						<ul className="dropdown-container scrollbar">
							{valueType === 'string'
								? list.content
										.filter((item) => !filters.includes(item))
										.map((item, index) => (
											<li
												key={index}
												onClick={(e) => {
													valueType === 'string'
														? setNewItem(item)
														: setNewItem(item.name);
												}}>
												{isTranslated && !freeInput
													? t(translationKey + '.' + item)
													: item}
											</li>
										))
								: list.content
										.filter(
											(item) =>
												!filters.some(
													(filterItem) =>
														filterItem?.name === item?.name ||
														filterItem === item?.name
												)
										)
										.map((item) => (
											<li
												key={item.code}
												onClick={() => {
													valueType === 'string'
														? setNewItem(item)
														: isFilter
														? setNewItem(item.name)
														: setNewItem(item);
												}}>
												{item.name}
											</li>
										))}
						</ul>
					)}
				</div>
			</div>
		</div>
	);
};

export default InputTag;
